import { Icon } from "components/lib";
import loading from "./images/loader.gif";

export function IconedButton(props) {
  return (
    <div
      style={{
        width: props.size,
        height: 50,
        backgroundColor: props.color,
        borderRadius: 10,
        color: props.textColor,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 15,
        fontWeight: 600,
        marginBottom: 10,
        marginRight: props.marginRight ? 10 : 0,
      }}
      onClick={props.action}
    >
      {props.loading ? (
        <>
          <img src={loading} style={{ width: 30 }} />
        </>
      ) : (
        <>
          <Icon image={props.icon} />
          <span style={props.iconWithoutMargin ? {} : { marginLeft: 10 }}>
            {props.text}
          </span>
        </>
      )}
    </div>
  );
}
